import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import DesktopLayout from 'shared/components/layout/DesktopLayout';
import HomePage from './Home/HomePage';
import CourseListPage from './CourseList/CourseListPage';
import CourseDetailsPage from './CourseDetails/CourseDetailsPage';
import CartPage from './Cart/CartPage';
import ContentDetailsPage from './ContentDetails/ContentDetailsPage';
import Signup from '../../../shared/view/login/Signup/Signup';
import StaticPagesView from './StaticPages/StaticPagesView';

type Props = {}

const LayoutClosed: React.FunctionComponent<Props> = () => {
    const AppLayout = DesktopLayout;
    return (
        <AppLayout>
            <Switch>
                <Route exact path="/" component={HomePage}/>
                <Route exact path="/pages/:mode" component={StaticPagesView}/>
                <Route exact path="/courses" component={CourseListPage}/>
                <Route exact path="/courses/:id" component={CourseDetailsPage}/>
                <Route exact path="/courses/:courseId/curriculums/:curriculumId/contents/:id" component={ContentDetailsPage}/>
            </Switch>
        </AppLayout>
    );
};

export default LayoutClosed;
